// Shared by world.ts and levels.ts
export const K = 'toothbrush';
export const DEG = Math.PI / 180;

/** Rising water: the surface rises to y = to at v px/frame, when the act `on` fires (or at once without `on`). The tap is drawn at tx, ty. */
export interface WaterRise { to: number; v?: number; on?: string; tx?: number; ty?: number }
/** Water: inside x0..x1, surface y, bottom y1. The water has no x (it spans x0..x1). */
export interface WaterProps {
  x0: number;
  x1: number;
  y: number;
  y1: number;
  /** Current (px/frame); negative = to the left */
  flow?: number;
  /** Braking in the water (default 0.06) */
  drag?: number;
  /** Narrow hole: sponge/soap snap to its middle */
  snap?: boolean;
  rise?: WaterRise;
  /** No parts may be placed from this y down to the water (e.g. under a shelf) */
  noplace?: number;
}
